<template>
  <v-app>
    <v-container fluid grid-list-lg>
        <v-card>          
          <v-app-bar flat>
            <v-icon>work_outline</v-icon>
            <v-toolbar-title class="font-weight-light">&nbsp;ABM de Situaciones Laborales</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn text icon color="red" sv-on="on" @click="setStatusTareaFrecuente(action)">
                  <v-icon v-if="action.esFrecuente">favorite</v-icon>
                  <v-icon v-else>favorite_border</v-icon>
                </v-btn>
              </template>
              <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
              <span v-else>Agregar a Tareas Frecuentes</span>  
            </v-tooltip>
          </v-app-bar>
          <v-card-text>
            <v-layout  wrap >               
                <v-flex xs12 sm6 md6 lg6>
                  <v-card>
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarList">
                      <v-icon>list</v-icon>
                      <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>
                      <v-spacer></v-spacer>                     
                    </v-app-bar>

                    <v-flex right>
                      <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Buscar por Nombre"
                          single-line
                          hide-details
                      ></v-text-field>
                    </v-flex>

                    <v-data-table 
                      :headers="headers"
                      :items="records"
                      :server-items-length="totalItems"
                      :loading="loading"
                      :options.sync="options"
                      v-model="selectedRow"
                      :footer-props="{itemsPerPageOptions:options.rowsPerPageItems}"
                    >
                      <template slot="no-data">
                        <v-alert :value="true" color="grey" icon="warning">
                          No se encontraron datos
                        </v-alert>
                      </template>
                      <template v-slot:item="{ item }">                
                          <tr @click="viewItem(item)">
                            <td class="text-xs-left">{{ item.descripcion }}</td>

                            <td class="text-xs-left">                
                              <v-icon small class="mr-2" @click="editItem(item)" v-show="canUpdate">edit</v-icon>
                              <v-icon small  @click="deleteItem(item)" v-show="canDelete">delete</v-icon>
                            </td>
                          </tr>
                      </template>
                    </v-data-table>
                  </v-card >
                </v-flex>
                <v-flex xs12 sm6 md6 lg6>
                  <v-card >
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarDetail">
                      <v-icon>add_box</v-icon>
                      <v-toolbar-title class="font-weight-light">Detalle</v-toolbar-title>
                      <v-spacer></v-spacer>
                      
                      <v-btn v-if="!editMode" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editItem()" v-show="canCreate">                        
                        <v-icon  medium>add_circle_outline</v-icon>
                      </v-btn>
                      
                      <v-btn v-if="model.id != null" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editMode = !editMode" v-show="canUpdate">
                        <v-icon v-if="editMode">cancel</v-icon>
                        <v-icon v-else>edit</v-icon>
                      </v-btn>
                    </v-app-bar>
                    <v-card-text>
                      <v-form :disabled="!editMode">
                          <v-layout>
                              <v-flex xs8>
                                  <v-text-field v-model="model.descripcion" label="Descripcion" required 
                                  :disabled="!editMode" v-validate="'required'" data-vv-name="descripcion" :error-messages="errors.collect('descripcion')"></v-text-field>
                              </v-flex>         
                              <v-flex xs4>
                                <v-switch label="Deshabilitada para Carga"
                                  v-model="model.anulado"
                                  :disabled="!editMode">
                                </v-switch>
                              </v-flex>

                          </v-layout>

                          <v-layout>
                              <v-flex xs4>
                                <v-switch label="Requiere Empleo"
                                  v-model="model.requiereEmpleo"
                                  :disabled="!editMode">
                                </v-switch>
                              </v-flex>         
                              <v-flex xs4>
                                    <v-text-field v-model="model.orden" label="Órden" required 
                                      :disabled="!editMode" v-validate="'required'" data-vv-name="orden" :error-messages="errors.collect('orden')"></v-text-field>
                              </v-flex>

                              <v-flex xs6>
                                  <v-text-field v-model="model.uiCarga" label="UI de Carga" required hint="Permite establecer la interfaz de carga (dejar en 0 si no está seguro)"
                                    :disabled="!editMode" v-validate="'required'" data-vv-name="orden" :error-messages="errors.collect('orden')"></v-text-field>
                              </v-flex>  
                              
                          </v-layout>
                          
                          <v-card>
                            <v-card-title>
                              <h3>Actividades de la Situación</h3>
                              <v-spacer></v-spacer>       
                              <v-btn fab small top @click="newActividad()" :disabled="!editMode">
                                <v-icon  medium>add_circle_outline</v-icon>
                              </v-btn>
                              
                            </v-card-title>
                            <v-card-text>
                               <template v-for="actividad in model.actividades">
                                <v-layout :key="actividad.id">
                                  <v-flex xs8>
                                    <h4>{{actividad.descripcion}} 
                                      <v-icon small class="mr-2" @click="editActividad(actividad)">edit</v-icon>
                                      <v-icon small color="red" class="mr-2" @click="deleteActividad(actividad)">delete</v-icon>
                                    </h4>  
                                    
                                    {{ actividad.requiereDescripcion? 'Require descripción':''}}
                                    {{ actividad.anulado? '(deshabilitado para carga)':''}}
                                    
                                  </v-flex>
                                </v-layout>
                              </template>
                            </v-card-text>
                            <v-card-actions >
                              <v-container>
                                <h3>Agregar/Modificar Actividad</h3>
                                <v-layout >
                                  <v-flex xs12>
                                    <v-text-field v-model="modelActividad.descripcion" :disabled="!editMode" label="Descripcion" ></v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout >                              
                                  <v-flex xs6>
                                    <v-switch label="Req.Descripción" v-model="modelActividad.requiereDescripcion" :disabled="!editMode"></v-switch>
                                  </v-flex>
                                  <v-flex xs6>
                                    <v-switch label="Deshabilitado" v-model="modelActividad.anulado" :disabled="!editMode"></v-switch>
                                  </v-flex>
                                </v-layout>
                                <v-btn  :disabled="!editMode" @click="addUpdateActividad">Agregar Actividad</v-btn>
                              </v-container>
                            </v-card-actions>
                          </v-card>

                          <v-divider></v-divider>
                          <template v-if="$store.state.debugModeOn">
                            Debug Info: <p></p>
                            
                            Model: {{model}}  <p></p>                            
                          </template>
                          <v-divider></v-divider>

                          <v-card-actions bottom>
                            <v-spacer></v-spacer> 
                            <v-btn color="success" :disabled="!editMode" @click="saveItem"><v-icon>save</v-icon>Guardar</v-btn>
                          </v-card-actions>
                        </v-form>
                    </v-card-text>
                  </v-card>
                </v-flex>
            </v-layout>
          </v-card-text>
        </v-card >
    </v-container>
</v-app>
</template>

<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      suspend: false,
      search: '', // valor para búsqueda
      options: { // definición de paginación
        sortDesc:[false],
        sortBy:[''],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems:[5,10,20]
      },
      totalItems: 0, // va afuera de options
      headers: [ // definición de columnas
        { text: 'Descripcion', value: 'descripcion' },
        { text: 'Acciones', value: 'name', sortable: false }
      ],        
      records: [], // registros
      selectedRow: [],
      tiposBaseCalculo: [],
      modelActividad: {id: 0, descripcion: "", anulado: false, requiereDescripcion: false},
      model: { } // registro para ver/editar
    };
  },
  async created() {
      
  },
  watch: {
    options :{
        handler(){
          this.getItems();
        },
        deep: true
    },
    search() {
        this.getItems();
    }
  },
  computed: {
    ...mapGetters(['checkCanCreate', 'checkCanUpdate', 'checkCanDelete', 'getActionFromLink']),
    canCreate: function(){
      return this.checkCanCreate(this.$route.path)
    },
    canUpdate: function(){
      return this.checkCanUpdate(this.$route.path)
    },
    canDelete: function(){
      return this.checkCanDelete(this.$route.path)
    },
    action: function(){
      return this.getActionFromLink(this.$route.path)
    }
  },
  methods: {
    ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),
    async addUpdateActividad(){
      
      if(this.modelActividad.id == 0){
        // agrego
        this.model.actividades.push({id: -(this.model.actividades.length + 1), descripcion: this.modelActividad.descripcion, anulado: this.modelActividad.anulado, requiereDescripcion: this.modelActividad.requiereDescripcion})
      }
      else{
        for (let index = 0; index <  this.model.actividades.length; index++) {
          var element =  this.model.actividades[index];
          if(element.id == this.modelActividad.id){
            element.descripcion = this.modelActividad.descripcion
            element.anulado = this.modelActividad.anulado
            element.requiereDescripcion = this.modelActividad.requiereDescripcion
          }
        }
      }
      this.editActividad()
    },
    async editActividad(actividad){
      if(actividad){
        this.modelActividad.id = actividad.id
        this.modelActividad.descripcion = actividad.descripcion
        this.modelActividad.anulado = actividad.anulado
        this.modelActividad.requiereDescripcion = actividad.requiereDescripcion
      }
      else{
        this.modelActividad.id = 0
        this.modelActividad.descripcion = ''
        this.modelActividad.anulado = false
        this.modelActividad.requiereDescripcion = false
      }
    },
    async deleteActividad(actividad){
      if(actividad){
        const index = this.model.actividades.indexOf(actividad);
        
        if (index > -1) {
          this.model.actividades.splice(index, 1);
        }

      }
    },    
    async newActividad(){
      this.editActividad()
    },
    async getItems() {
      this.loading = true
      this.$validator.reset()

      try {          
        var result = await http.get('situacioneslaborales?descripcion='+this.search + '&limit='+this.options.itemsPerPage+'&page='+this.options.page+
                                    '&sortby='+this.options.sortBy+'&descending='+(this.options.sortDesc.length > 0 ? this.options.sortDesc : 'false'));

        this.records = result.list;
        this.totalItems = result.totalCount
      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.loading = false
    },
    async resetState(){      
      this.$validator.reset()
      this.editMode = false;
    },
    async getItem(id) {
      this.loading = true
      this.resetState()
    
      try {
        
        var result = await http.get('situacioneslaborales/' +id );
        Vue.$log.debug(this.model);
        Vue.$log.debug(result);
        
        this.model = result;
      } catch (error) {
        // Error        
        this.alertError(error)
      }
      
      this.loading = false
    },    
    async viewItem(item){
      if(this.suspend) return;

      this.selectedRow.pop()
      this.selectedRow.push(item)

      await this.getItem(item.id);
      this.editMode = false;      
    },
    async clearAndReload(){
        // Clear the data inside of the form
        this.model = {status: {}}
        this.resetState()

        // Refresco la grilla
        await this.getItems()
    },
    async editItem(item){
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)
      
      if(!item)
        await this.getItem(0);
      else
        await this.getItem(item.id);
      
      this.editMode = true;
      this.suspend = false;
    },
    async cancelEdit() {
      this.editMode = false;
    },
    async saveItem() {
      const isUpdate = !(this.model.id === 0);
      
      await this.$validator.validateAll();

      if(this.errors.items.length > 0) return;

      if (isUpdate) {
        try{
          await http.put('situacioneslaborales', JSON.stringify( {situacionLaboral:  this.model} ) );
          this.alertSuccess('Los cambios han sido guardados.');
          this.clearAndReload();
        } 
        catch(error){          
          // Error
          this.alertError(error)
        }               
      } else {
        try{          
          await http.post('situacioneslaborales', JSON.stringify( {situacionLaboral:  this.model} ) );
          this.alertSuccess('Los cambios han sido guardados.')
          this.clearAndReload();
        } 
        catch(error){
          // Error          
          this.alertError(error)
        }         
      }
    },
    async deleteItem(item) {      
      if (confirm('¿Confirma la eliminación de la situación ' + item.descripcion + '?')) {
        try{            
            var result = await http.delete('situacioneslaborales?id='+item.id );
            this.alertSuccess('La Situación Laboral ha sido eliminada.')
            this.clearAndReload();
        }
        catch(error){
            // Error            
            this.alertError(error)
        }
      }
    },
  }
}
</script>